import { disableScrolling, enableScrolling } from '@/functions/scrolling'

const header = document.querySelector('.js-header')
const button = document.querySelector('.js-header-button')
const headerLogo = document.querySelector('.header__logo')
const headerLogoSmall = document.querySelector('.header__logo.small')
const headerHomeLink = document.querySelector('.header__home-link')

// Keep up-to-date with $breakpoint-header in CSS
const breakpoint = window.matchMedia('(min-width: 80rem)')

/**
 * Expand header
 */
function expand () {
  header.classList.add('is-expanded')
  headerLogo.classList.add('is-expanded')
  headerHomeLink.appendChild(headerLogo)
  headerLogoSmall.remove()
  button.setAttribute('aria-expanded', 'true')
  button.setAttribute('aria-label', 'Contract header')

  if (!breakpoint.matches) {
    disableScrolling()
  }
}

/**
 * Contract header
 */
function contract () {
  header.classList.remove('is-expanded')
  headerLogo.classList.remove('is-expanded')
  headerHomeLink.appendChild(headerLogoSmall)
  headerLogo.remove()
  button.setAttribute('aria-expanded', 'false')
  button.setAttribute('aria-label', 'Expand header')

  enableScrolling()
}

/**
 * Toggle header state
 */
function toggle () {
  if (header.classList.contains('is-expanded')) {
    contract()
  } else {
    expand()
  }
}

if (header && breakpoint.matches) {
  header.classList.add('is-expanded')
}

if (header && button) {
  button.addEventListener('click', toggle)
}

if (header) {
  breakpoint.addListener(event => {
    if (event.matches) {
      expand()
      enableScrolling()
    } else {
      contract()
    }
  })
}

if (header && button && global.IntersectionObserver) {
  const observer = new IntersectionObserver(entries => {
    if (breakpoint.matches && entries[0].isIntersecting) {
      expand()
    } else if (breakpoint.matches) {
      contract()
    }
  })

  const sentinel = document.createElement('div')
  sentinel.style.height = '100px'
  sentinel.style.position = 'absolute'
  sentinel.style.top = '0'
  header.parentNode.insertBefore(sentinel, header)

  observer.observe(sentinel)
}

// change logo on site load
window.onload = function () {
  if (breakpoint.matches) {
    expand()
  } else {
    contract()
  }
}
